import { IoIosArrowDown } from "react-icons/io";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import CustomDialog from "./DialougeBox";
import { MdOutlineDone } from "react-icons/md";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { label } from "framer-motion/client";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const AddNewClient = () => {
  const { baseUrl, openToast } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);
  function handleCloseForm() {
    navigate("/clients");
  }
  const navigate = useNavigate();
  const [defaultLanguages, setDefaultLanguages] = useState([
    "English",
    "Hindi",
    "portuguese",
    "German",
    "indonesia",
    "catlan",
    "Spanish",
    "Turkish",
    "Slovak",
    "Vitnamese",
    "Swedish",
    "Portguese_br",
    "ukrainian",
    "polish",

  ]);
  const [toggleCurrencyDropdown, setToggleCurrencyDropDown] = useState(false);

  const handleToggleCurrencyDropDown = () => {
    setToggleCurrencyDropDown(!toggleCurrencyDropdown);
  };

  const [selectAll, setSelectAll] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);

  const groups = [
    "ASTROPITAH SMM PROJECT",
    "digital",
    "HONEY TOUR & TRAVELS",
    "vevge",
    "webs",
  ];

  const handleGroupSelection = (selectAll) => {
    if (selectAll) {
      setSelectedGroups(groups); //select all group
      setSelectAll(true);
    } else {
      setSelectedGroups([]); //deselect all group
      setSelectAll(false);
    }
  };
  const toggleGroupSelection = (group) => {
    setSelectedGroups((prevSelected) =>
      prevSelected.includes(group)
        ? prevSelected.filter((g) => g !== group)
        : [...prevSelected, group]
    );
  };

  const [clientName, setClientName] = useState("");
  const [company, setCompany] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [currency, setCurrency] = useState(["₹"]);
  const [language, setLanguage] = useState(["English"]);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [country, setCountry] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "client", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify({
          name: clientName,
          company: company,
          vat_number: vatNumber,
          phone: phone,
          website: website,
          address: address,
          country: country,
          state: state,
          city: city,
          zip_code: zipCode,
          default_language: language,
          groups: selectedGroups,
          currency: currency,
          email: email,
          password,
        }),
      });
      const data = await result.json();
      if (result.status == 201) {
        setIsLoading(false);
        openToast(data.msg || "Add Client Successfully", "success");
        navigate("/clients");
      } else {
        openToast(data.message || "An Error occured", "error");
      }
    } catch (error) {
      openToast(error.message || "An Error occured", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center pb-[20px] min-h-screen">
      <div className="border-gray-100 bg-white shadow-cs mt-[20px] md:mt-[30px] p-[20px] border rounded-lg w-[90%] md:w-[80%]">
        {/* <Link to = "/clients"><FaArrowLeft /></Link> */}
        <div className="mb-6">
          {/* <!-- Tabs for form sections --> */}
          <nav className="flex sm:flex-row flex-col items-center gap-[10px] md:gap-[20px] pb-[10px] border-b">
            <Link
              to="#"
              className="hover:border-[#27004a] py-2 hover:border-b-1 font-medium text-[13px] md:text-[16px]"
            >
              Customer Details
            </Link>
            {/* <a
              href="#"
              className="hover:border-[#27004a] py-2 hover:border-b-1 font-medium text-[13px] text-gray-600 md:text-[16px]"
            >
              Billing & Shipping
            </a> */}
          </nav>
        </div>

        {/* <!-- Form starts --> */}
        <form onSubmit={handleSubmit}>
          <div className="gap-6 grid grid-cols-1">
            {/* <!-- Company --> */}
            <div>
              <label
                for="name"
                className="block font-medium text-gray-700 text-sm"
              >
                Name  <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setClientName(e.target.value);
                }}
                id="company"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                name="name"
                required
              />
            </div>

            {/* <!-- Company --> */}
            <div>
              <label
                for="company"
                className="block font-medium text-gray-700 text-sm"
              >
                Company <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
                id="company"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="company"
                required
              />
            </div>

            {/* <!-- VAT Number --> */}
            <div>
              <label
                for="vat"
                className="block font-medium text-gray-700 text-sm"
              >
                VAT Number
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setVatNumber(e.target.value);
                }}
                placeholder="XX123456732"
                id="vat"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="vat"
                required
              />
            </div>

            {/* <!-- email --> */}
            <div>
              <label
                for="email"
                className="block font-medium text-gray-700 text-sm"
              >
                Email  <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                id="phone"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="email"
                required
              />
            </div>

            {/* <!-- Phone --> */}
            <div>
              <label
                for="phone"
                className="block font-medium text-gray-700 text-sm"
              >
                Phone  <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                id="phone"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                name="phone"
                required
              />
            </div>

            {/* <!-- Website --> */}
            <div>
              <label
                for="website"
                className="block font-medium text-gray-700 text-sm"
              >
                Website
              </label>
              <input
                type="url"
                onChange={(e) => {
                  setWebsite(e.target.value);
                }}
                id="website"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="website"

              />
            </div>

            {/* <!-- Groups --> */}

            <div className="relative">
              <label
                for="groups"
                className="block font-medium text-gray-700 text-sm"
              >
                Groups
              </label>
              <Select
                closeMenuOnSelect={false}
                isMulti
                onChange={(o) => {
                  const arr = o.map((op) => op.value);
                  setSelectedGroups(arr);
                }}
                options={groups.map((g) => {
                  return { value: g, label: g };
                })}
                required
              />
            </div>

            {/* <!-- Currency and Default Language in one row --> */}
            <div className="flex md:flex-row flex-col justify-between items-center gap-[8px] w-full">
              {/* <!-- Currency --> */}

              <div className="inline-block relative w-[100%] md:w-[50%] text-left">
                <label
                  htmlFor="currency"
                  className="block font-medium text-gray-700 text-sm"
                >
                  Currency
                </label>
                <Select
                  name="currency"
                  closeMenuOnSelect={false}
                  isMulti
                  // defaultValue={[
                  //   { label: "INR", value: "₹" },
                  // ]}
                  onChange={(o) => {
                    const arr = o.map((op) => op.value);
                    setCurrency(arr);
                  }}
                  options={[
                    { label: "USD", value: "$" },
                    { label: "INR", value: "₹" },
                  ]}
                  required

                />
              </div>

              {/* <!-- Default Language --> */}
              <div className="mt-[22px] md:mt-[0] ml-0 w-[100%] md:w-[50%]">
                <label
                  for="language"
                  className="block font-medium text-gray-700 text-sm"
                >
                  Default Language
                </label>
                <Select
                  name="language"
                  closeMenuOnSelect={false}
                  isMulti
                  // defaultValue={[
                  //   { label: "English", value: "English" },
                  // ]}
                  onChange={(o) => {
                    const arr = o.map((op) => op.value);
                    setLanguage(arr);
                  }}
                  options={defaultLanguages.map((op) => {
                    return { label: op, value: op };
                  })}
                  required
                />
              </div>
            </div>

            {/* <!-- Address --> */}
            <div>
              <label
                for="address"
                className="block font-medium text-gray-700 text-sm"
              >
                Address
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
                id="address"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="address"

              />
            </div>

            {/* <!-- City --> */}
            <div>
              <label
                for="city"
                className="block font-medium text-gray-700 text-sm"
              >
                City
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setCity(e.target.value);
                }}
                id="city"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="city"

              />
            </div>

            {/* <!-- State --> */}
            <div>
              <label
                for="state"
                className="block font-medium text-gray-700 text-sm"
              >
                State
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setState(e.target.value);
                }}
                id="state"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="state"

              />
            </div>

            {/* <!-- Zip Code --> */}
            <div>
              <label
                for="zip"
                className="block font-medium text-gray-700 text-sm"
              >
                Zip Code
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setZipCode(e.target.value);
                }}
                id="zip"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm"
                name="zip"

              />
            </div>

            {/* <!-- Country --> */}
            <div>
              <label
                for="country"
                className="block font-medium text-gray-700 text-sm"
              >
                Country
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setCountry(e.target.value);
                }}
                id="country"
                className="block border-gray-300 shadow-sm mt-1 p-2 border rounded-md w-full sm:text-sm focus-visible:outline-none"
                name="country"

              />
            </div>
            <div>
              <label
                for="name"
                className="block font-medium text-gray-700 text-sm"
              >
                Password  <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                id="password"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                required
              />
            </div>
            <div>
              <label
                for="name"
                className="block font-medium text-gray-700 text-sm"
              >
                Confirm Password  <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                id="password"
                className="block border-gray-300 shadow-smsm:text-sm mt-1 p-2 border rounded-md w-full focus-visible:outline-none"
                required
              />
            </div>
          </div>


          {/* <!-- Submit Button --> */}
          <div className="flex justify-end gap-[10px] mt-6 p-2 w-full">
            <button
              onClick={handleCloseForm}
              className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className={`allcrm-btn1 ${isLoading ? "second-btn-disabled" : "second-btn"}`}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
        {/* <!-- Form ends --> */}
      </div>
    </div>
  );
};

export default AddNewClient;
